import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export const getAgencyCode = async (agencyCode: string) => {
  const path = `/agencies/${encodeURIComponent(agencyCode)}`;
  const params = {};
  let result: any;
  await API.get(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
